import styled from "@emotion/styled";
import { MDSText } from "@/mds/components/text";

export const StyledShortcutKeyWrapper = styled.div<{ $inline?: boolean; $isFixedWidth?: boolean }>(
  ({ theme, $inline, $isFixedWidth }) => ({
    display: $inline ? "inline-flex" : "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "16px",
    width: $isFixedWidth ? "16px" : "auto",
    paddingBlock: "1px",
    paddingInline: $isFixedWidth ? "1px" : "3px",
    borderRadius: theme.borderRadius.small,
    border: `1px solid ${theme.colors.border.onAccent}`,
  })
);

export const StyledShortcutKeyText = styled(MDSText)(({ theme }) => ({
  fontSize: "11px",
  lineHeight: theme.lineHeights["text-sm"],
  fontWeight: theme.fontWeights.medium,
  color: theme.colors.text.secondary,
}));
